if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          buttonNext: this.querySelector('.slider-button.slider-button--next'),
          buttonPrev: this.querySelector('.slider-button.slider-button--prev'),
        };

        this.mql = window.matchMedia('(min-width: 5px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

        this.elements.buttonPrev.addEventListener('click', () => this.setActiveMediaPrev());
        this.elements.buttonNext.addEventListener('click', () => this.setActiveMediaNext());

        // Impliment swipe behavior for mobile
        var xDown = null;
        this.elements.viewer.addEventListener('touchstart', (evt) => {
          xDown = evt.touches[0].clientX;
        });

        this.elements.viewer.addEventListener('touchmove', (evt) => {
          if (!xDown) {
            return;
          }
          var xUp = evt.touches[0].clientX;
          var xDiff = xDown - xUp;

          if (Math.abs(xDiff) > 10) {
            if (xDiff > 0) {
              /* left swipe */
              this.setActiveMediaNext();
            } else {
              /* right swipe */
              this.setActiveMediaPrev();
            }
          }

          /* reset values */
          xDown = null;
        });
      }

      setActiveMediaNext() {
        const nextMedia = this.elements.viewer.querySelector('.is-active').nextElementSibling;
        const mediaId = nextMedia ? nextMedia.dataset.mediaId : this.elements.viewer.querySelector('li:first-child').dataset.mediaId;
        if (mediaId) {
          this.setActiveMedia(mediaId, false);
        }
      }
      setActiveMediaPrev() {
        const nextMedia = this.elements.viewer.querySelector('.is-active').previousElementSibling;
        const mediaId = nextMedia ? nextMedia.dataset.mediaId : this.elements.viewer.querySelector('li:last-child').dataset.mediaId;
        if (mediaId) {
          this.setActiveMedia(mediaId, false);
        }
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {

        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);

        // if (activeMedia.previousElementSibling == null) {
        //   this.elements.buttonPrev.setAttribute('disabled', true);
        // } else {
        //   this.elements.buttonPrev.removeAttribute('disabled');
        // }

        // if (activeMedia.nextElementSibling == null) {
        //   this.elements.buttonNext.setAttribute('disabled', true);
        // } else {
        //   this.elements.buttonNext.removeAttribute('disabled');
        // }

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
